import PhoneticText from './src/PhoneticText.vue'

export default PhoneticText